// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Utils & Helpers
import { VIP_STATUS } from "helpers/constants";

// #####################################################

const useGetTextLimitMessages = () => {
	const { user } = useSelector((store) => store.global);

	const { t } = useTranslation(["common", "suspensions"]);

	const { status_vip } = user;

	if (status_vip <= VIP_STATUS.VERIFIED) {
		return {
			statusVip: status_vip,
			redirectToSuperVip: false,
			translateMessage: t("common:cantCommentLimitWhenNoVipShort"),
		};
	} else if (status_vip === VIP_STATUS.VIP) {
		return {
			statusVip: status_vip,
			redirectToSuperVip: true,
			translateMessage: t("common:cantCommentLimitWhenVipShort"),
		};
	}
	// ** Domyślny warunek
	return {
		statusVip: status_vip,
		redirectToSuperVip: false,
		translateMessage: "",
	};
};

export default useGetTextLimitMessages;
